import { createApiWithNoBasePath as api } from "@api";

export const resendEmailService = async (email: string) => {
  const csrfToken = (
    document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement
  ).content;
  const response = await api.post(
    `/resend_confirmation_email`,
    {
      email,
    },
    {
      headers: {
        "x-csrf-token": csrfToken,
      },
    }
  );

  try {
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
